interface VehicleDetailHeaderProps {
  vehicle: any;
  titleColor: string;
  textColor: string;
  formatPrice: (price: number) => string;
}

export function VehicleDetailHeader({
  vehicle,
  titleColor,
  textColor,
  formatPrice,
}: VehicleDetailHeaderProps) {
  const tags: { label: string; accent?: boolean }[] = [];

  if (vehicle.isZeroKm) {
    tags.push({ label: 'Zero KM', accent: true });
  } else if (vehicle.mileage > 0) {
    tags.push({ label: 'Seminovo' });
  }

  return (
    <header className="wl6-vd-header">
      <div className="wl6-vd-header__row">
        <div>
          <h1 className="wl6-vd-header__title" style={{ color: titleColor }}>
            {vehicle.brand} {vehicle.model}
          </h1>
          {vehicle.version && (
            <p className="wl6-vd-header__version" style={{ color: textColor }}>
              {vehicle.version}
            </p>
          )}
        </div>
        <div className="wl6-vd-header__price">{formatPrice(vehicle.price)}</div>
      </div>

      {tags.length > 0 && (
        <div className="wl6-vd-tags">
          {tags.map((tag) => (
            <span
              key={tag.label}
              className={`wl6-vd-tag${tag.accent ? ' wl6-vd-tag--accent' : ''}`}
            >
              {tag.label}
            </span>
          ))}
        </div>
      )}
    </header>
  );
}
